export const ModeSwitchIcon: React.FC = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M9 14L4 9l5-5"></path>
    <path d="M4 9h11a5 5 0 0 1 0 10h-1"></path>
  </svg>
);
